
var progressInterval;

var controls = `
    <div id="controls-bar">
      <div id="video-controls" class="controls">
          <button id="playpause" type="button">PAUSE</button>
          <button id="duration" type="button" ></button>
          <div class="progress">
             <progress id="progress" value="0" min="0" max="0">
                <span id="progress-bar"></span>
             </progress>
          </div>
          <div class="right">
            <button id="mute" type="button" data-state="mute">unmute</button>
			<button id="fullscreen" type="button" >Fullscreen</button>
          </div>
      </div>
    </div>`;

function buildControls(player){
  
  console.log("build controls")

  if($("#controls-bar")){
    $("#controls-bar").remove();
  }

  if(progressInterval){
    clearInterval(progressInterval);
  }

  $(player).after(controls);
  
  setTimeout(function(){
	$("#video-controls").fadeIn()
  },500);

  progressLoop();

  $("#playpause").on("click",function(){
    if ($(this).text() == "Play") {
      $(this).text("Pause");
      player.play();
    } else {
      $(this).text("Play");
      player.pause();
    }
  });

  // MUTE

  $("#mute").on("click",function(){

    if($(this).text() == "Mute"){

      $(this).text("Unmute");
      player.muted = 1;

    }else{

      $(this).text("Mute");
      player.muted = 0;

    }

  });


  // FULLSCREEN

  $("#fullscreen").on("click",function(){

    var player = $("video")[0];
    
    if (player.requestFullscreen) {
      player.requestFullscreen();
    } else if (player.mozRequestFullScreen) {
      player.mozRequestFullScreen();
    } else if (player.webkitRequestFullscreen) {
      player.webkitRequestFullscreen();
    } else {
    player.webkitEnterFullScreen()
    }
    
  });

//   $("video").bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
      
//       var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      
//       if(state == false){
//       }
  
//   });


  // PROGRESS

  const progress = document.getElementById("progress");
  
  function progressLoop() {
    
    progressInterval = setInterval(function () {

      progress.value = player.currentTime;
      
      var time = secondsToTime(player.currentTime)
      var minutes = ("0" + time.m).slice(-2);
      var seconds = ("0" + time.s).slice(-2);
  
      $("#duration").text(minutes + ":" + seconds);
      $("#progress").attr("max", player.duration)

    },100);

  }
  
  function secondsToTime(secs){
  
    secs = Math.round(secs);
    var hours = Math.floor(secs / (60 * 60));
    
    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);
    
    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    
    var obj = {
        "h": hours,
        "m": minutes,
        "s": seconds
    };
    return obj;
  
  }

  // SEEK

  
  $("#progress").attr("max", $(player).attr("data-duration"))
  $("#progress").attr("value", 0)
  
  clickToSeek();

  function clickToSeek(){

    $("progress").on("click", function(e){
    
      var percentage = (e.offsetX/$("progress").width())
      var rate = player.duration*percentage;
    
      player.currentTime = rate;
    
    });

  }

} 

  
var randomSlide = 1; 
var count = 0;

$("#campaign p,#campaign span").each(function(){
  
 
      
 if($(this).text().indexOf("mp4") > -1){
   
   
   var player = "<video muted muted autoplay loop webkit-playsinline playsinline style='width: 100%'><source src='"+$(this).text()+"' type='video/mp4'></source></video>"
  var slide = "<div style='width: 100%'>" + player + "</div>"
  
  $(slide).appendTo(".swiper-wrapper");
   
  var play = $(".swiper-wrapper").find("video")[0];
   
      
         if(play){
        
           buildControls(play);
           
           
           play.addEventListener('canplaythrough', function() {

  		   	if(play.readyState >= 2) {
              setTimeout(function(){play.play()},1000)
              console.log("ready")
  			}

			});
         
           
           
         }   
   
   
  $(this).remove();
   
  count++;
    
}
  
if($(this).text().indexOf("youtube") > -1){

  $(".swiper-wrapper").append('<div id="player"></div>')
    // 2. This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
  
});
  
  
  $("#articleBody iframe").each(function(){
    
    
 var a = "<div class='swiper-slide'>"+ $(this)[0].outerHTML+"</div>"

 $(a).appendTo(".swiper-wrapper");
  
});
  



// console.log()
  
  
  
// if ($("video").length > 0){
  
// $("video")[randomSlide].oncanplay = function() {
//     $("video")[randomSlide].play()
// };
  
    
// }
  
// $("#articleBody img").each(function(){

//  var a = "<div class='swiper-slide'><img src='"+ $(this).attr("src")+"'/></div>"

//  $(a).appendTo(".swiper-wrapper");
  
// });
  

//  var mySwiper = new Swiper ('.swiper-container', {
//    loop: true,
//    initialSlide: randomSlide - 1,
//     keyboard: true,
//    autoHeight: true,
//     pagination: {
//       el: '.swiper-pagination',
//       clickable: true,
//     },
//     centeredSlides: true,
//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },
//   });
  
//  mySwiper.on('slideChange', function (a,b) {

//    if ($("video").length > 0){
//      $("video").each(function(){
//        $(this)[0].pause();
//      })
//     $("video")[mySwiper.activeIndex].play();
//    }
// }); 
 
// $(".slideshow").prependTo(".main-content");
  
//   if($(".swiper-slide").length < 1){
//     $(".swiper-button-prev,.swiper-button-next").hide()
//   }
  
  
//   if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
//   var v = $("video").eq(1)
//   v[0].play()
  
//   }
// $(".site-header").css("color","white")
// $(".site-header__logo-link.black").hide()
// $(".site-header__logo-link.white").show()
  
//   console.log(count)
//   if(count < 2){
//   	$(".swiper-button-prev,.swiper-button-next").hide();
//   }